const fr = {
  time_zone: 'Fuseau Horaire',
  chart: 'Graphique',

  //Timeframes every
  every: 'Chaque',
  granularity: 'Granularité',
  second: 'seconde',
  seconds: 'secondes',
  seconds_short: 's',
  minute: 'minute',
  minutes: 'minutes',
  minute_short: 'm',
  hour: 'heure',
  hours: 'heures',
  hour_short: 'h',
  day: 'jour',
  days: 'jours',
  no_auto_refresh_short: 'Aucun',

  // chrono units
  nanos: 'Nanos',
  micros: 'Micros',
  millis: 'Millis',
  half_days: 'Demi-jours',
  weeks: 'Semaines',
  months: 'Mois',
  years: 'Années',
  decades: 'Décennies',
  centuries: 'Siècles',
  millennia: 'Millénaires',
  eras: 'Ères',
  forever: 'Pour toujours',

  // Status
  on: 'Activé',
  off: 'Désactivé',
  auto: 'Automatique',

  //common
  sensor_index: 'Indice du capteur',
  slave_device_number: 'Numéro de l’appareil esclave',
  select: 'Sélectionner',
  create: 'Créer',
  update: 'Mettre à jour',
  relay_index: 'Indice du relais',
  devices: 'Appareils',
  device_name: 'Nom de l’appareil',
  device_number: 'Numéro de l’appareil',

  //command status
  pending: 'En attente',
  sent: 'Envoyé',
  cancelled: 'Annulé',
  status_ok: 'Ok',
  status_nok: 'Pas Ok',
  timeout: 'Délai dépassé',
  unknown: 'Inconnu',

  //Text
  text_add: 'Ajouter',
  text_edit: 'Modifier',
  no_data_for_selected_period: "Il n'y a pas de données pour la période spécifiée",
  choose_location: 'Choisir un emplacement',
  more_information: "Plus d'informations",
  track_device: "Suivre l'appareil",
  not_found: 'Non trouvé',
  powered_by: 'Propulsé par ',

  // Solution types
  solution_none: 'Non assigné',
  solution_agri: 'Agriculture',
  solution_air_quality: "Qualité de l'air",
  solution_street_lights: 'Éclairage public',
  solution_pump_station: 'Station de pompage',
  solution_smart_waste: 'Déchets Intelligents',
  solution_level: 'Surveillance du niveau',
  solution_gas: 'Surveillance du gaz',
  solution_pressure: 'Surveillance de la pression',
  solution_smart_water: 'Eau Intelligente',
  solution_energy: "Surveillance de l'énergie",
  solution_environment_monitoring: "Surveillance de l'environnement",

  //Control buttons
  add_button: 'Ajouter',
  edit_button: 'Modifier',
  save_button: 'Enregistrer',
  cancel_button: 'Annuler',
  clear_button: 'Effacer',
  language_button: 'Langue',
  logout_button: 'Déconnexion',
  change_info_for_field: 'Modifier les informations du terrain', //Context needed
  on_button: 'Activé', //Context needed
  off_button: 'Désactivé', //Context needed
  auto_button: 'Auto',
  toggle_button: 'Basculer', //Context needed
  door_open_sensor_text: 'Ouvert',
  door_closed_sensor_text: 'Fermé',
  no_auto_refresh: 'Pas de rafraîchissement automatique',
  refresh_now: 'Rafraîchir maintenant',

  //Drawer form fields
  drawer_field_information_text: 'Informations sur le terrain', //Context needed
  drawer_devices_config: 'Configuration des dispositifs',
  drawer_layer_name: 'Nom du calque', //Context needed
  drawer_status: 'Statut',
  drawer_region_name: 'Nom de la région',
  drawer_description: 'Description',
  drawer_layer_size: 'Taille du calque', //Context needed
  drawer_previous_culture: 'Culture précédente', //Context needed
  drawer_device: 'Dispositif',
  drawer_sensor: 'Capteur',

  //Menu
  menu_home: 'Accueil',
  menu_calendar: 'Calendrier',
  menu_journal: 'Journal',
  menu_alarms: 'Événements',
  menu_new_home: 'Accueil (Nouveau)',
  menu_old_home: 'Accueil (Ancien)',
  menu_streetlight: 'Éclairage public',
  menu_trashbags: 'Sacs à déchets',
  menu_collections: 'Collectes',
  menu_truck_collections: 'Collectes par Camion',
  menu_truck_collections_by_container: 'Collectes par Camion par Conteneur',
  menu_container_collections: 'Collectes par Conteneur',
  menu_reports: 'Rapports',

  //Map banner text
  map_banner_select: 'Sélectionner un champ',
  map_banner_create: 'Créer un champ',
  map_cluster_devices_header: 'Appareils ({{deviceCount}})',

  //Field information widget
  field_info_view: 'Vue',
  field_info_events: 'Événements',
  field_info_header: 'Informations sur le champ',
  field_info_status: 'STATUT',
  field_info_region: 'RÉGION',
  field_info_description: 'Description',
  field_info_area: 'SUPERFICIE',
  field_info_previous_culture: 'CULTURE PRÉCÉDENTE', //Context needed
  field_info_linked_devices: 'Appareils Liés',
  field_info_distance_traveled: 'Distance Parcourue',

  //Forecast widget
  forecast_today: "Aujourd'hui",
  forecast_three_days: '3 jours',
  forecast_five_days: '5 jours',
  forecast_seven_days: '7 jours',
  forecast_min_temp: 'TEMP MIN',
  forecast_max_temp: 'TEMP MAX',
  forecast_cloud_cover: 'COUVERTURE NUAGEUSE',
  forecast_rain: 'PLUIE',
  forecast_wind: 'VENT',
  forecast_wind_direction: 'DIRECTION DU VENT',
  forecast_humidity: 'HUMIDITÉ',

  //Rain Widget
  rain_widget_header: 'Pluie',

  //Humidity Widget
  humidity_widget_text: 'Humidité',

  //Soil Moisture Widget
  soil_moisture_widget_text: 'Humidité du sol',

  //Control Widget
  control_widget_header: 'Contrôle',
  relay_control_get_relay_statuses: 'Obtenir les statuts des relais',
  poll_linked_devices: 'Interroger les appareils liés',

  //Sensor information widget
  sensor_reference_values_label: 'Valeurs de référence',
  sensor_board_label: 'TABLEAU ÉLECTRIQUE',
  sensor_all_info_header: 'Capteurs',
  sensor_info_header: 'Informations sur le capteur',
  sensor_info_name: 'Nom',
  sensor_info_device: 'Dispositif',
  sensor_info_type: 'Type',
  sensor_info_status: 'Statut',
  sensor_info_max: 'Max',
  sensor_info_min: 'Min',
  sensor_info_avg: 'Moyenne',
  sensor_info_current: 'Actuel',
  sensor_info_counters: 'Compteurs', //Context needed
  sensor_info_start_button: 'DÉMARRER',
  sensor_info_stop_button: 'ARRÊTER',
  sensor_last_refresh: 'Rafraîchir : {{time}}',
  sensor_info_board: 'TABLEAU',
  sensor_info_manufacturer: 'Fabricant',
  sensor_info_model: 'Modèle',
  sensor_info_serial_number: 'Numéro de série',
  sensor_info_diameter: 'Diamètre',

  //Street lights information widget
  power_usage: 'CONSOMMATION ÉLECTRIQUE',
  lighting: 'ÉCLAIRAGE',
  lights_on: 'Allumé',
  lights_off: 'Éteint',
  door_open: 'Ouvert',
  door_closed: 'Fermé',

  //Pump station information
  pump1: 'Pompe 1',
  pump2: 'Pompe 2',

  //Device Information
  device_information_name: 'Nom',
  device_information_number: 'Numéro',
  device_information_model: 'Modèle',
  device_information_latitude: 'Latitude',
  device_information_longitude: 'Longitude',

  //Widget detailed button
  widget_detailed_button: 'Détails', //Context needed

  //Back To Map Button
  back_to_map_btn: 'Retour à la carte',

  //Wind widget
  wind_widget_header: 'Vent',

  //Dashboard
  boiler_condition_information: "Informations sur l'état de fonctionnement de la chaudière",
  street_light_information: "Informations sur l'éclairage public",
  pump_station_information: 'Informations sur la station de pompage',
  default_information_panel: 'Informations sur le dispositif',
  dashboard_header: 'Tableau de bord pour le champ :',
  dashboard_chart_value: 'valeur',
  select_sensor_message: 'Sélectionner un capteur',

  //OnOffAutoLoader
  await_command_execution: "Veuillez attendre l'exécution de la commande",
  command_successful: 'Commande exécutée avec succès',
  command_unsuccessful: "Erreur lors de l'exécution de la commande",
  command_error: 'Commande non exécutée',
  loading: 'Chargement',

  //Alarms
  alarms_page_header: 'Événements',
  alarms_page_device_header: 'Événements pour le dispositif {{deviceNumber}}',

  alarms_table_date_header: 'Date',
  alarms_table_device_number_header: 'Numéro de dispositif',
  alarms_table_type_header: 'Type',
  alarms_table_description_header: 'Description',
  alarms_table_sensor_name: 'Nom du capteur',

  alarms_none_message: 'Aucun événement pour la période sélectionnée',
  alarms_control_panel_select_date_message: 'Sélectionner une date',
  alarms_control_panel_from_date: 'Date de début',
  alarms_control_panel_to_date: 'Date de fin',
  alarms_control_panel_alarm_type: "Type d'événement",
  alarms_control_panel_alarm_status: "Statut de l'événement",
  alarms_control_panel_by_device_number: 'Rechercher par numéro de dispositif',
  alarms_control_panel_header: "Filtres d'événements",

  // Value ranges
  value_ranges_light_rain: 'Pluie légère',
  value_ranges_moderate_rain: 'Pluie modérée',
  value_ranges_heavy_rain: 'Pluie forte',
  value_ranges_violent_rain: 'Pluie violente',
  value_ranges_calm_wind: 'Vent calme',
  value_ranges_light_air: 'Légère brise',
  value_ranges_light_breeze: 'Brise légère',
  value_ranges_gentle_breeze: 'Petite brise',
  value_ranges_moderate_breeze: 'Brise modérée',
  value_ranges_fresh_breeze: 'Bonne brise',
  value_ranges_strong_breeze: 'Brise forte',
  value_ranges_high_wind: 'Vent fort',
  value_ranges_gale: 'Coup de vent',
  value_ranges_severe_gale: 'Fort coup de vent',
  value_ranges_storm: 'Tempête',
  value_ranges_violent_storm: 'Violente tempête',
  value_ranges_hurricane: 'Ouragan',
  value_ranges_north_1: 'Nord',
  value_ranges_north_notheast: 'Nord-Nord-Est',
  value_ranges_notheast: 'Nord-Est',
  value_ranges_east_notheast: 'Est-Nord-Est',
  value_ranges_east: 'Est',
  value_ranges_east_southeast: 'Est-Sud-Est',
  value_ranges_southeast: 'Sud-Est',
  value_ranges_south_south_east: 'Sud-Sud-Est',
  value_ranges_south: 'Sud',
  value_ranges_south_southwest: 'Sud-Sud-Ouest',
  value_ranges_southwest: 'Sud-Ouest',
  value_ranges_west_southwest: 'Ouest-Sud-Ouest',
  value_ranges_west: 'Ouest',
  value_ranges_west_northwest: 'Ouest-Nord-Ouest',
  value_ranges_northwest: 'Nord-Ouest',
  value_ranges_north_northwest: 'Nord-Nord-Ouest',
  value_ranges_north_2: 'Nord',
  value_ranges_dry: 'Sec',
  value_ranges_normal: 'Normal',
  value_ranges_wet: 'Humide',
  value_ranges_frost_point: 'Point de gelée',
  value_ranges_frost_point_danger: 'Danger de gelée',
  value_ranges_dew_point: 'Point de rosée',

  // Data Table Widget
  data_table_widget_header: 'Données',
  data_table_measurements: 'Mesures',
  data_table_alarms: 'Alarmes',
  data_table_widget_from_date: 'Date de début',
  data_table_widget_to_date: 'Date de fin',
  data_table_date: 'Date',
  data_table_value: 'Valeur',
  data_table_range: 'Intervalle',
  flow: 'Flux',
  raw_readings: 'Données Brutes',
  y_axis_include_zero: "Inclure 0 sur l'axe Y",
  chart_options: 'Options du graphique',

  //sensors types
  rain_sensor: 'Capteur de pluie',
  level_sensor: 'Capteur de niveau',
  wind_speed_sensor: 'Capteur de vitesse du vent',
  wind_direction_sensor: 'Capteur de direction du vent',
  water_meter: "Capteur de compteur d'eau",
  pressure_sensor: 'Capteur de pression',
  humidity_sensor: "Capteur d'humidité",
  temperature_sensor: 'Capteur de température',
  gas_flow_meter: 'Débitmètre de gaz',
  heat_meter: 'Compteur de chaleur',
  barometric_pressure_sensor: 'Capteur de pression barométrique',
  soil_moisture_sensor: "Capteur d'humidité du sol",
  on_off_sensor: 'Interrupteur relais',
  generic_analog_sensor: '--',
  power_meter: "Compteur d'énergie",
  soil_temperature_sensor: 'Température du sol',
  dew_point_sensor: 'Point de rosée',
  particulate_matter_sensor: 'Capteur de particules',
  geiger_mueller_counter: 'Radiation',
  soil_potential_sensor: 'Potentiel du sol',
  weight_sensor: 'Capteur de poids',

  sensor: {
    rain: {
      name: 'Capteur de pluie',
      valueRanges: {
        no_rain: {
          abbrv: 'Sans pluie',
          description: 'Quand le taux de précipitation est < 0,1 mm par heure',
        },
        light_rain: {
          abbrv: 'Pluie légère',
          description: 'Quand le taux de précipitation est entre 0,1 et 2,5 mm par heure',
        },
        moderate_rain: {
          abbrv: 'Pluie modérée',
          description: 'Quand le taux de précipitation est entre 2,5 et 7,6 mm par heure',
        },
        heavy_rain: {
          abbrv: 'Pluie forte',
          description: 'Quand le taux de précipitation est entre 7,6 et 50 mm par heure',
        },
        violent_rain: {
          abbrv: 'Pluie violente',
          description: 'Quand le taux de précipitation est > 50 mm par heure',
        },
      },
    },
    windDirection: {
      name: 'Direction du vent',
      valueRanges: {
        north_1: {
          abbrv: 'N',
          description: 'Nord (349° - 011°)',
        },
        north_2: {
          abbrv: 'N',
          description: 'Nord (349° - 011°)',
        },
        north_northeast: {
          abbrv: 'NNE',
          description: 'Nord-Nord-Est (012°-033°)',
        },
        northeast: {
          abbrv: 'NE',
          description: 'Nord-Est (034°-056°)',
        },
        east_northeast: {
          abbrv: 'ENE',
          description: 'Est-Nord-Est (102°-123°)',
        },
        east: {
          abbrv: 'E',
          description: 'Est (079°-101°)',
        },
        east_southeast: {
          abbrv: 'ESE',
          description: 'Est-Sud-Est (102°-123°)',
        },
        southeast: {
          abbrv: 'SE',
          description: 'Sud-Est (124°-146°)',
        },
        south_southeast: {
          abbrv: 'SSE',
          description: 'Sud-Sud-Est (147°-168°)',
        },
        south_southwest: {
          abbrv: 'SSW',
          description: 'Sud-Sud-Ouest (192°-213°)',
        },
        south: {
          abbrv: 'S',
          description: 'Sud (169°-191°)',
        },
        southwest: {
          abbrv: 'SW',
          description: 'Sud-Ouest (214°-236°)',
        },
        west_southwest: {
          abbrv: 'WSW',
          description: 'Ouest-Sud-Ouest (237°-258°)',
        },
        west: {
          abbrv: 'W',
          description: 'Ouest (259°-281°)',
        },
        west_northwest: {
          abbrv: 'WNW',
          description: 'Ouest-Nord-Ouest (282°-303°)',
        },
        northwest: {
          abbrv: 'NW',
          description: 'Nord-Ouest (304°-326°)',
        },
        north_northwest: {
          abbrv: 'NNW',
          description: 'Nord-Nord-Ouest (327°-348°)',
        },
      },
    },
    windSpeed: {
      name: 'Capteur de vitesse du vent',
      valueRanges: {
        no_wind: {
          abbrv: 'Sans vent',
          description: '(0 m/s - 0,1 m/s)',
        },
        calm_wind: {
          abbrv: 'Vent calme',
          description: '(0,1 m/s - 1 m/s)',
        },
        light_air: {
          abbrv: 'Léger souffle',
          description: '(2 m/s - 3 m/s)',
        },
        light_breeze: {
          abbrv: 'Brise légère',
          description: '(4 m/s - 6 m/s)',
        },
        gentle_breeze: {
          abbrv: 'Petite brise',
          description: '(7 m/s - 10 m/s)',
        },
        moderate_breeze: {
          abbrv: 'Brise modérée',
          description: '(11 m/s - 16 m/s)',
        },
        fresh_breeze: {
          abbrv: 'Bonne brise',
          description: '(17 m/s - 21 m/s)',
        },
        strong_breeze: {
          abbrv: 'Brise forte',
          description: '(22 m/s - 27 m/s)',
        },
        high_wind: {
          abbrv: 'Vent fort',
          description: '(28 m/s - 33 m/s)',
        },
        gale: {
          abbrv: 'Coup de vent',
          description: '(34 m/s - 40 m/s)',
        },
        severe_gale: {
          abbrv: 'Fort coup de vent',
          description: '(41 m/s - 47 m/s)',
        },
        storm: {
          abbrv: 'Tempête',
          description: '(48 m/s - 55 m/s)',
        },
        violent_storm: {
          abbrv: 'Violente tempête',
          description: '(56 m/s - 63 m/s)',
        },
        hurricane: {
          abbrv: 'Ouragan',
          description: '(64 m/s - 77 m/s)',
        },
      },
    },
    soil_temperature: {
      valueRanges: {
        idealMin: {
          abbrv: 'Croissance lente',
          description: 'Croissance lente - la température est < 18,3°C',
        },
        idealMax: {
          abbrv: 'Conditions idéales',
          description: 'Conditions idéales (entre 18,4°C et 30°C)',
        },
        warm: {
          abbrv: 'Chaud',
          description: 'Croissance plus lente (entre 30,1°C et 32,2°C)',
        },
        hot: {
          abbrv: 'Très chaud',
          description: 'Croissance inefficace (entre 32,3°C et 45°C)',
        },
        dangerous: {
          abbrv: 'Dangereux',
          description: "Bactéries mourantes, perte d'humidité (> 45,1°C)",
        },
      },
    },
    soilmoisture: {
      valueRanges: {
        dry: {
          abbrv: 'Sec',
          description: 'Humidité du sol dangereusement basse (< 80%)',
        },
        normal: {
          abbrv: 'Irriguer',
          description: 'Irrigation nécessaire (entre 80% et 90%)',
        },
        wet: {
          abbrv: 'Humide',
          description: "Pas d'irrigation nécessaire (entre 90% et 100%)",
        },
      },
    },
    dew_point_sensor: {
      valueRanges: {
        frost_point: {
          abbrv: 'Gelée',
          description: 'Le point de rosée est inférieur à 1°C.',
        },
        frost_point_danger: {
          abbrv: 'Danger de gelée',
          description: 'Le point de rosée est inférieur à 5°C.',
        },
        dew_point: {
          abbrv: 'Point de rosée',
          description: 'Le point de rosée est supérieur à 5°C.',
        },
      },
    },
    gammaRadiation: {
      valueRanges: {
        normal: {
          abbrv: 'Normal',
        },
        abnormal: {
          abbrv: 'Élevé',
        },
        dangerous: {
          abbrv: 'Dangereusement élevé',
        },
      },
    },
    moisture: {
      valueRanges: {
        dry: {
          abbrv: 'Sec',
        },
        normal: {
          abbrv: 'Normal',
        },
        wet: {
          abbrv: 'Humide',
        },
      },
    },
    temperature: {
      valueRanges: {
        cool: {
          abbrv: 'Frais',
        },
        ideal: {
          abbrv: 'Idéal',
        },
        warm: {
          abbrv: 'Chaud',
        },
        hot: {
          abbrv: 'Très chaud',
        },
        dangerous: {
          abbrv: 'Dangereusement chaud',
        },
      },
    },
    airMicroGrams: {
      valueRanges: {
        good: {
          abbrv: 'Bas',
        },
        moderate: {
          abbrv: 'Modéré',
        },
        minimal: {
          abbrv: 'Minimal',
        },
        sensitive: {
          abbrv: 'Sensible',
        },
        discomfort: {
          abbrv: 'Inconfort',
        },
        unhealthy: {
          abbrv: 'Malsain',
        },
        veryUnhealthy: {
          abbrv: 'Très malsain',
        },
        hazardous: {
          abbrv: 'Dangereux',
        },
        respiratoryIllness: {
          abbrv: 'Dangereux (maladies respiratoires)',
        },
        healthImpact: {
          abbrv: 'Dangereux pour la santé',
        },
      },
    },
    barometricPressure: {
      valueRanges: {
        low: {
          abbrv: 'Bas',
          description: 'La pression barométrique est inférieure à 850.',
        },
        normal: {
          abbrv: 'Normal',
          description: 'La pression barométrique est comprise entre 850 et 1500',
        },
        high: {
          abbrv: 'Élevé',
          description: 'La pression barométrique est supérieure à 1500 mais inférieure à 3000',
        },
      },
    },
    load_cells: {
      valueRanges: {
        low: {
          abbrv: 'Normal',
          description: 'La charge est inférieure à 999 kN.',
        },
        normal: {
          abbrv: 'Avertissement',
          description: 'La charge est comprise entre 1000 et 1100 kN',
        },
        high: {
          abbrv: 'Alarme',
          description: 'La charge est supérieure à 1100 kN',
        },
      },
    },
  },

  //GEOMAN MAP LIBRARY CUSTOM TRANSLATE
  // --tooltips--
  placeMarker: 'Cliquez pour placer un marqueur',
  firstVertex: 'Cliquez pour placer le premier sommet', //Context needed
  continueLine: 'Cliquez pour continuer à dessiner',
  finishLine: 'Cliquez sur un marqueur existant pour terminer',
  finishPoly: 'Cliquez sur le premier marqueur pour terminer',
  finishRect: 'Cliquez pour terminer',
  startCircle: 'Cliquez pour placer le centre du cercle',
  finishCircle: 'Cliquez pour terminer le cercle',
  placeCircleMarker: 'Cliquez pour placer le marqueur circulaire',
  placeText: 'Cliquez pour placer le texte',

  // -- actions --
  finish: 'Terminer',
  cancel: 'Annuler',
  removeLastVertex: 'Supprimer le dernier sommet', //Context needed

  // -- button titles --
  drawMarkerButton: 'Dessiner un marqueur',
  drawPolyButton: 'Dessiner des polygones',
  drawLineButton: 'Dessiner une ligne',
  drawCircleButton: 'Dessiner un cercle',
  drawRectButton: 'Dessiner un rectangle',
  editButton: 'Modifier le calque',
  dragButton: 'Déplacer le calque',
  cutButton: 'Couper le calque',
  deleteButton: 'Supprimer le calque',
  drawCircleMarkerButton: 'Dessiner un marqueur circulaire',
  snappingButton: 'Aligner le marqueur déplacé avec les autres calques et sommets',
  pinningButton: 'Fixer les sommets partagés ensemble',
  rotateButton: 'Faire pivoter le calque',
  drawTextButton: 'Dessiner du texte',

  //CONFIRMATION DIALOG WINDOW
  confirmMessage: 'Êtes-vous sûr de vouloir supprimer ceci (polygone ou zone) ?',
  confirmAgreeButton: 'Accepter',
  confirmDisagreeButton: 'Refuser',

  //Journal
  journal_page_header: 'Journal',

  //Calendar
  calendar_page_header: 'Calendrier',

  //Period-Selector options
  period_label: 'Période',
  route_date_selector: 'Date de trajet',

  period_date_range_option: 'Plage de dates',
  period_custom_option: 'Personnalisé',
  period_today_option: "Aujourd'hui",
  period_week_option: 'Semaine',
  period_month_option: 'Mois',
  period_last_h_option: 'Dernière heure',
  period_last_2_h_option: 'Dernières 2 heures',
  period_last_4_h_option: 'Dernières 4 heures',
  period_last_24_h_option: 'Dernières 24 heures',
  period_last_48_h_option: 'Dernières 48 heures',

  //YAMBOL HEADER
  municipality_yambol: 'Municipalité de Yambol',

  //Devices List
  search_placeholder: 'Rechercher le nom du dispositif',

  //Error-handling
  toast_server_error_message: 'Une erreur est survenue lors de votre requête au serveur',
  toast_alarms_error_message: 'Échec de la récupération des alarmes',
  toast_map_error_message: 'Échec de la récupération de la carte',
  toast_dashboard_error_message: 'Échec de la récupération du tableau de bord',
  toast_devices_error_message: 'Échec de la récupération des dispositifs',
  toast_device_config_error_message:
    "Échec de la récupération de la configuration de l'appareil pour : {{deviceNumber}}",
  toast_device_current_values_error_message:
    'Échec de la récupération des valeurs actuelles pour : {{deviceNumber}}',
  toast_devices_location_error_message: "Échec de la récupération de l'emplacement des dispositifs",
  toast_map_setting_per_name_error_message:
    'Échec de la récupération des paramètres de la carte actuelle',
  toast_map_settings_error_message: 'Échec de la récupération de tous les paramètres de la carte',
  toast_get_user_error_message: 'Échec de la récupération de votre utilisateur',
  toast_set_user_language_error_message: 'Échec de la modification de la langue',

  //CurrentValuesBox
  current_values_box_info_description: 'Aucune information',
  current_values_box_reference_values: 'Valeurs de référence',
  device_info_panel_loading_values: 'Chargement des valeurs actuelles',
  device_info_panel_no_values: 'Aucune valeur actuelle disponible',
  device_info_panel_values_error: 'Impossible de charger les valeurs actuelles',

  // Buttons and dropdowns
  alarms_export_header: 'Alarmes',
  alarms_export_header_with_device: `Alarmes : {{device_number}}`,
  alarms_export_search: 'Rechercher',
  alarms_export_download: 'Télécharger',
  alarms_export_format: 'Format',

  // Table columns
  alarms_export_table_date: 'Date',
  alarms_export_table_device_number: 'Numéro du dispositif',
  alarms_export_table_device_name: 'Nom du dispositif',
  alarms_export_table_sensor_index: 'Index du capteur',
  alarms_export_table_sensor_name: 'Nom du capteur',
  alarms_export_table_alarm_type: 'Type',
  alarm_type_on_off_alarm: 'Alarme marche/arrêt',
  alarm_type_no_zero_consumption: 'Aucune consommation nulle',
  alarm_type_all_zero_consumption: 'Consommation nulle',
  alarm_type_low_flow: 'Débit faible',
  alarm_type_high_flow: 'Débit élevé',
  alarm_type_high_consumption: 'Consommation élevée',
  alarm_type_missed_transmission: 'Transmission manquée',
  alarm_type_device_removed: 'Appareil retiré',
  alarm_type_low_level: 'Niveau bas',
  alarm_type_high_level: 'Niveau haut',
  alarm_type_tamper: 'Sabotage',
  alarm_type_oversized: 'Surdimensionné',
  alarm_type_undersized: 'Sous-dimensionné',
  alarm_type_low_battery: 'Batterie faible',
  alarm_type_blockage: 'Blocage',
  alarm_type_burst: 'Rupture',
  alarm_type_reverse_flow: 'Débit inversé',
  alarm_type_range_event: 'Événement de plage',
  alarm_type_very_low_level: 'Niveau très bas',
  alarm_type_very_high_level: 'Niveau très haut',
  alarm_type_leakage: 'Fuite',
  alarm_type_low_temperature: 'Température basse',
  alarm_type_no_consumption: 'Aucune consommation',
  alarm_type_negative_flow: 'Débit négatif',
  alarm_type_empty_spool: 'Conduite vide',
  alarm_type_combination_of_alarms: 'Combinaison d’alarmes',
  alarm_type_standstill: 'Arrêt',
  alarm_type_reset_error: 'Erreur de réinitialisation',
  alarm_type_rf_error: 'Erreur RF',
  alarm_type_cs_error: 'Erreur CS',
  alarm_type_measuring_error: 'Erreur de mesure',
  alarm_type_reset_event: 'Réinitialisation',
  alarm_type_magnetic_field: 'Champ magnétique',
  alarm_type_sensor_fraud: 'Fraude sur le capteur',
  alarms_export_table_severity: 'Gravité',
  alarm_severity_tooltip: 'Gravité : {{value}} sur 10',
  alarm_severity_none_tooltip: 'Aucune gravité signalée pour cette alarme',
  alarms_export_table_alarm_status: 'Statut',
  alarms_export_table_description: 'Description',
  alarms_export_chip_status_active: 'Actif',
  alarms_export_chip_status_inactive: 'Inactif',
  alarms_export_switch_title_label: 'Rafraîchissement automatique',
  alarms_export_error_alert_message: 'Une erreur est survenue lors de la génération des données.',
  alarms_export_error_too_big_query:
    "La récupération de l'historique à partir de Super Admin pour tous les dispositifs est trop volumineuse. Veuillez sélectionner une entreprise.",

  /*
   * |=================|
   * | Task Scheduler  |
   * |=================|
   */

  task_scheduler_link_label: 'Planificateur',
  task_scheduler_title: 'Planificateur de tâches',
  task_scheduler_remove: 'Supprimer',
  task_scheduler_remove_confirmation: 'Êtes-vous sûr de vouloir supprimer la tâche ?',
  task_scheduler_confirm: 'Confirmer',
  task_scheduler_cancel: 'Annuler',
  task_scheduler_remove_active: 'Impossible de supprimer une tâche active',
  task_scheduler_action_not_reversible: 'Cette action est irréversible.',
  task_scheduler_edit: 'Modifier',

  // Form
  task_scheduler_form_name: 'Nom de la tâche',
  task_scheduler_form_from_date: 'Date de début',
  task_scheduler_form_to_date: 'Date de fin',
  task_scheduler_form_repeat: 'Répéter',
  task_scheduler_form_period: 'Période',
  task_scheduler_form_temporal: 'Temporel',
  task_scheduler_form_execution_hour: "Heure d'exécution",
  task_scheduler_form_execution_minute: "Minute d'exécution",

  // Toast messages
  task_scheduler_form_create_message: 'Tâche créée avec succès',
  task_scheduler_form_update_message: 'Tâche modifiée avec succès',
  task_scheduler_form_create_error_message:
    'Une erreur est survenue lors de la création de la tâche',
  task_scheduler_form_update_error_message:
    'Une erreur est survenue lors de la modification de la tâche',
  task_scheduler_form_delete_message: 'Tâche supprimée avec succès',

  // Task execution
  task_execution_error_loading_message: 'Impossible de charger les exécutions de tâches',

  // Tasks list
  scheduled_tasks_list_event_name: "Nom de l'événement",
  scheduled_tasks_list_start_date: 'Date de début',
  scheduled_tasks_list_end_date: 'Date de fin',
  scheduled_tasks_list_execution_time: "Heure d'exécution",
  scheduled_tasks_list_last_execution: 'Dernière exécution',
  scheduled_tasks_list_is_active: 'Est actif',
  scheduled_tasks_event_logs_btn_text: "Journaux d'événements",
  scheduled_tasks_view_btn_text: 'Voir',

  // History table
  scheduled_event_history_title: 'Historique des tâches',
  scheduled_tasks_history_date_of_execution_header: "Date d'exécution",
  scheduled_tasks_history_status_header: "Statut d'exécution",
  scheduled_tasks_history_overview_btn_text: 'Aperçu',
  scheduled_tasks_history_task_status_done: 'Terminé',
  scheduled_tasks_history_task_status_pending: 'En attente',
  scheduled_tasks_history_task_status_failed: 'Échoué',
  scheduled_tasks_history_task_status_done_with_errors: 'Terminé avec des erreurs',

  // Task Overview
  task_scheduler_command_task_overview: 'Aperçu des tâches',
  task_overview_scheduled_event_name: 'Nom de l’événement planifié',
  task_overview_desired_state: 'État souhaité',
  task_overview_command_state: 'État de la commande',

  // Event Form
  scheduled_task_event_form_required_state: 'État requis',
  scheduled_task_event_form_required_states: 'États requis',
  scheduled_task_event_form_scheduled_event: 'Événement programmé',
  scheduled_task_event_form_new_scheduled_event: 'Nouvel événement programmé',
  scheduled_task_event_form_edit_scheduled_event: 'Événement programmé modifier',
  scheduled_task_event_form_event_type: "Type d'événement",
  scheduled_task_event_form_start_date: 'Date de début',
  scheduled_task_event_form_end_date: 'Date de fin',
  scheduled_task_event_form_last_execution: 'Dernière exécution',
  scheduled_task_event_form_execution_time: "Heure d'exécution",
  scheduled_task_event_form_relay_state: 'État du relais',
  scheduled_task_event_form_select: 'Sélectionner',
  scheduled_task_event_form_hour: "Heure d'exécution de l'appareil",
  scheduled_task_event_form_minute: "Minute d'exécution de l'appareil",
  scheduled_task_event_form_modbus_command_type: 'Type de commande',
  scheduled_task_event_form_modbus_command_type_read_coil_1: 'Obtenir l’état du relais',
  scheduled_task_event_form_modbus_command_type_read_register_3: 'Lire la valeur',
  scheduled_task_event_form_modbus_command_type_write_coil_5: 'Envoyer la commande',

  // Scheduled task event types
  command_type_single_relay_switch: 'Interrupteur à relais unique',
  command_type_relay_switch: 'Interrupteur à relais',
  command_type_auto_relay_switch: 'Interrupteur à relais automatique',
  command_type_send_date_over_mqtt: 'Envoyer la date via MQTT',
  command_type_modbus: 'Modbus',
  command_type_tasmota_power: 'Puissance Tasmota',
  command_type_scheduled_relay_command: 'Relais programmé',
  command_type_scheduled_relay_command_4: 'Commandes de relais programmées (4)',
  command: 'Commande',

  // Error handling
  scheduled_tasks_could_not_find_event_with_id: `Impossible de trouver l\'événement planifié avec l\'ID : {{event_id}}`,
  scheduled_tasks_could_not_get_event_logs_for_event:
    "Échec de la récupération des journaux pour l'événement",
  scheduled_tasks_could_not_update_event_with_id:
    "Impossible de mettre à jour l'événement planifié avec l'ID : {{event_id}}",
  logo_error_message: 'Impossible de charger le logo de l’entreprise',

  //resolvers
  scheduled_tasks_event_name_min_length:
    "Le nom de l'événement doit comporter au moins 3 caractères",
  scheduled_tasks_event_name_max_length:
    "Le nom de l'événement doit comporter moins de 50 caractères",
  scheduled_tasks_from_date_invalid: "La date de début doit être postérieure à aujourd'hui",
  scheduled_tasks_to_date_invalid: 'La date de fin doit être postérieure à la date de début',
  scheduled_tasks_execution_hour_range: "L'heure d'exécution doit être comprise entre 0 et 23",
  scheduled_tasks_execution_minute_range: "La minute d'exécution doit être comprise entre 0 et 59",
  scheduled_tasks_period_required: 'La période doit être un entier positif',
  scheduled_tasks_temporal_required: 'Une valeur temporelle est requise',
  scheduled_tasks_event_device_numbers_length:
    'Chaque numéro de dispositif doit comporter exactement 8 caractères',
  scheduled_tasks_event_sensor_index_range: "L'indice du capteur doit être un entier positif ou 0",
  scheduled_tasks_event_relay_states_required:
    'Les états du relais doivent être spécifiés pour le type RELAY_SWITCH',
  scheduled_tasks_event_required_state_auto_relay:
    'Un état requis doit être spécifié pour le type AUTO_RELAY_SWITCH',
  scheduled_tasks_event_required_state_tasmota_power:
    'Un état requis doit être spécifié pour le type TASMOTA_POWER',
  scheduled_tasks_event_slave_device_number_length:
    "Le numéro de l'appareil esclave doit comporter exactement 8 caractères",
  scheduled_tasks_event_type_invalid: "Type d'événement invalide sélectionné",
  scheduled_tasks_device_number_is_required:
    'Sélectionnez un ou plusieurs appareils pour créer un événement',

  /*
   * |=====================|
   * | License Error Page  |
   * |=====================|
   */
  license_error_page_access_restricted: 'Accès restreint',
  license_warning_access_hold: 'Accès au compte suspendu',
  license_warning_access_hold_description:
    'Votre accès à la plateforme a été temporairement suspendu en raison d’un paiement non résolu. Nous vous encourageons à contacter notre support ou votre représentant désigné pour résoudre ce problème.',
  license_warning_no_valid_license: 'Licence non valide',
  license_warning_no_valid_license_description:
    "Nous n'avons pas trouvé de licence valide associée à ce compte. Veuillez contacter votre représentant désigné ou notre support pour obtenir de l’aide.",
  license_warning_devices_count_limit_reached: 'Nombre maximal de dispositifs atteint',
  license_warning_devices_count_limit_reached_description:
    'Vous avez atteint le nombre maximal de dispositifs pouvant être associés à ce compte via la licence. Pour en ajouter davantage, veuillez contacter votre représentant désigné ou notre support.',
  license_warning_generic_title: 'Aucune licence',
  license_warning_generic_description:
    "Impossible de continuer en raison d'un problème de licence.",
  error_forbidden_operation_not_allowed: 'Non autorisé',

  /*
   * |=================|
   * | Trashbags       |
   * |=================|
   */
  trashbags_page_header: 'Sacs à déchets',
  trashbags_status_new: 'Nouveau',
  trashbags_status_in_progress: 'En cours',
  trashbags_status_closed: 'Fermé',
  trashbags_fetch_error: 'Erreur lors de la récupération des lots',
  trashbags_batch_details_error: 'Erreur lors de la récupération des détails du lot',
  trashbags_batch_number: 'Rouleau de sacs',
  trashbags_batch_id: 'ID du rouleau',
  trashbags_total_count: 'Total',
  trashbags_new: 'Nouveau',
  trashbags_in_progress: 'En cours',
  trashbags_closed: 'Fermé',
  trashbags_id: 'ID',
  trashbags_rfid: 'RFID',
  trashbags_status: 'Statut',
  trashbags_account_number: 'Numéro de lot',
  trashbags_created_date: 'Date de création',
  trashbags_collection_date: 'Date de collecte',
  trashbags_more_info_tooltip: "Cliquez pour voir plus d'informations",
  trashbags_details_title: 'Détails du sac',
  trashbags_type: 'Type',
  trashbags_location: 'Emplacement',
  trashbags_open_in_maps: 'Ouvrir dans Google Maps',
  trashbags_empty_title: 'Aucun rouleau de sacs trouvé',
  trashbags_empty_description: "Il n'y a pas encore de rouleaux de sacs a afficher.",
  trashbags_batch_empty_title: 'Aucun sac dans ce rouleau',
  trashbags_batch_empty_description: 'Ce rouleau ne contient pas encore de sacs.',

  /*
   * |=================|
   * | Collections     |
   * |=================|
   */
  collections_page_header: 'Rapport de Collecte des Déchets',
  collections_fetch_error: 'Erreur lors de la récupération des données de collecte',
  collections_from_date: 'Date de début',
  collections_to_date: 'Date de fin',
  collections_account_number: 'Numéro de lot',
  collections_account_id: 'ID du compte',
  collections_count: 'Nombre de collectes',
  collections_volume: 'Volume de collecte',
  collections_export_csv: 'Exporter',
  collections_no_data_to_export: 'Aucune donnée à exporter',

  /*
   * |====================|
   * | Truck Collections  |
   * |====================|
   */
  truck_collections_page_header: 'Rapport Collectes par Camion',
  truck_collections_fetch_error:
    'Erreur lors de la récupération des données de collecte par camion',
  truck_collections_from_date: 'Date de début',
  truck_collections_to_date: 'Date de fin',
  truck_collections_truck_name: 'Nom du camion',
  truck_collections_count: 'Nombre de collectes',
  truck_collections_volume: 'Volume de collecte',
  truck_collections_export_csv: 'Exporter CSV',
  truck_collections_view_on_map: 'Voir sur la carte',
  truck_collections_no_data_to_export: 'Aucune donnée à exporter',

  /*
   * |================================|
   * | Truck Collections by Container |
   * |================================|
   */
  truck_collections_by_container_page_header: 'Rapport Collectes par Camion par Conteneur',
  truck_collections_by_container_fetch_error:
    'Erreur lors de la récupération des collectes par conteneur',
  truck_collections_by_container_from_date: 'Date de début',
  truck_collections_by_container_to_date: 'Date de fin',
  truck_collections_by_container_truck_number: 'Nom du camion',
  truck_collections_by_container_container_number: 'Numéro de conteneur',
  truck_collections_by_container_container_address: 'Adresse du conteneur',
  truck_collections_by_container_location: 'Emplacement',
  truck_collections_by_container_status: 'Statut',
  truck_collections_by_container_date: 'Date',
  truck_collections_by_container_status_correct: 'Emplacement correct',
  truck_collections_by_container_status_incorrect: 'Emplacement incorrect',
  truck_collections_by_container_open_in_maps: 'Ouvrir dans Google Maps',
  truck_collections_by_container_export_csv: 'Exporter CSV',
  truck_collections_by_container_view_on_map: 'Voir sur la carte',
  truck_collections_by_container_no_data_to_export: 'Aucune donnée à exporter',

  /*
   * |=======================|
   * | Container Collections |
   * |=======================|
   */
  container_collections_page_header: 'Rapport Collectes par Conteneur',
  container_collections_fetch_error: 'Erreur lors de la récupération des collectes par conteneur',
  container_collections_from_date: 'Date de début',
  container_collections_to_date: 'Date de fin',
  container_collections_container_number: 'Numéro de conteneur',
  container_collections_container_address: 'Adresse du conteneur',
  container_collections_account_id: 'ID du compte',
  container_collections_account_number: 'Numéro de compte',
  container_collections_count: 'Nombre de collectes',
  container_collections_volume: 'Volume de collecte',
  container_collections_export_csv: 'Exporter CSV',
  container_collections_no_data_to_export: 'Aucune donnée à exporter',

  // Common
  close_btn: 'Fermer',

  // TanstackTable UI
  table_search_placeholder: 'Rechercher…',
  table_columns: 'Colonnes',
  table_toggle_all: 'Tout basculer',
  table_filter: 'Filtrer',
  table_clear_filter: 'Effacer le filtre',
  table_pin_left: 'Épingler à gauche',
  table_pin_right: 'Épingler à droite',
  table_unpin: 'Détacher',
  table_group_by_column: 'Grouper par cette colonne',
  table_ungroup: 'Dégrouper',
  table_filter_all: 'Tous',
  table_no_values: 'Aucune valeur',
  table_min: 'Min',
  table_max: 'Max',
  table_equals: 'Égal à',
  table_from: 'De',
  table_to: 'À',
  table_yes: 'Oui',
  table_no: 'Non',
  table_filter_placeholder: 'Filtrer…',
  table_density_compact: 'Compact',
  table_density_standard: 'Standard',
  table_density_comfortable: 'Confortable',
  table_auto_page_size: 'Auto ({rows})',
};

export default fr;
